/*models/tiles/index*/
function _(require, module, exports) {
    var bbox_tile_source_1 = require(206    /* ./bbox_tile_source */);
    exports.BBoxTileSource = bbox_tile_source_1.BBoxTileSource;
    var mercator_tile_source_1 = require(209    /* ./mercator_tile_source */);
    exports.MercatorTileSource = mercator_tile_source_1.MercatorTileSource;
    var quadkey_tile_source_1 = require(210    /* ./quadkey_tile_source */);
    exports.QUADKEYTileSource = quadkey_tile_source_1.QUADKEYTileSource;
    var tile_renderer_1 = require(211    /* ./tile_renderer */);
    exports.TileRenderer = tile_renderer_1.TileRenderer;
    var tile_source_1 = require(212    /* ./tile_source */);
    exports.TileSource = tile_source_1.TileSource;
    var tms_tile_source_1 = require(214    /* ./tms_tile_source */);
    exports.TMSTileSource = tms_tile_source_1.TMSTileSource;
    var wmts_tile_source_1 = require(215    /* ./wmts_tile_source */);
    exports.WMTSTileSource = wmts_tile_source_1.WMTSTileSource;    
}